import icon from './K_icon';
import shared from './const_share';

export const QUALITY_CONTROL_AGENT = 'Krist Perkins';

const config = {
  serverUrl:
    process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '',
  dev: 'jesseteal@gmail.com',
  icon,
  ...shared,
};
export default config;
